import React, { useState } from 'react';
import {
  IonCol,
  IonIcon,
  IonLabel,
  IonRow,
  useIonAlert,
  IonBadge
} from '@ionic/react';
import { unlinkOutline, pencilOutline } from 'ionicons/icons';

import SelectForm from '../../../../common/controls/SelectForm';

import {
  acceptDeleteRiskUpdated,
  getCurrentLinkedRisks,
  linkedRisksUpdated
} from '../../../../../store/evaluation/environment/Recommendations';
import {
  getCurrentEnvironmentRiskRows,
  getEvaluationRisks,
  risksUpdated
} from '../../../../../store/evaluation/Risks';
import { useAppDispatch, useAppSelector } from '../../../../../store/Hooks';

import {
  patchRisk,
  getSeverityAbbreviation,
  getSeverityColor
} from '../../../../../services/risk.service';

import AlertModal from '../../../../common/AlertModal';
import { findIndex } from 'lodash';

const Risk: React.FC<any> = (props: any) => {
  const {
    index,
    data,
    removeRisk,
    riskSeverityList,
    getRecommendationRiskData,
    isReadOnlyMode
  } = props;
  const dispatch = useAppDispatch();
  const [presentAlert] = useIonAlert();
  const [valueRisk, setValueRisk] = useState<string>(data.risk.severity);
  const [showConfirmAlert, setShowConfirmAlert] = useState<boolean>(false);
  const currentLinkedRisks = useAppSelector(getCurrentLinkedRisks);
  const currentEnvironmentRiskRows = useAppSelector(
    getCurrentEnvironmentRiskRows
  );
  const risks = useAppSelector(getEvaluationRisks);

  const openRiskSeverityModal = () => {
    setShowConfirmAlert(true);
  };

  const handleSetAcceptDeleteRisk = async (value: boolean) => {
    dispatch({
      type: acceptDeleteRiskUpdated.type,
      payload: value
    });
  };

  const handleUpdateRisksTab = (id: number, row: any) => {
    let risksTemp = [...risks];
    console.log(risksTemp);

    if (risksTemp && risksTemp.length > 0) {
      const index = findIndex(risks, { id: row.id });
      risksTemp[index] = row;

      dispatch({
        type: risksUpdated.type,
        payload: risksTemp
      });
    }
  };

  const handlerUpdateSeverity = (value: string | null) => {
    if (data.risk.severity !== value) {
      let currentLinkedRisksTemp = [...currentLinkedRisks];
      let riskTemp = { ...data.risk };
      riskTemp.severity = value;
      let temp = { ...data, risk: riskTemp };

      for (const [index, row] of currentLinkedRisks.entries()) {
        if (row.risk.id === data.risk.id) {
          currentLinkedRisksTemp[index] = temp;
        }
      }

      dispatch(
        patchRisk({
          id: data.idRisk,
          severity: value
        })
      );

      dispatch({
        type: linkedRisksUpdated.type,
        payload: currentLinkedRisksTemp
      });

      handleUpdateRisksTab(data.idRisk, riskTemp);
      setShowConfirmAlert(false);
    } else {
      setShowConfirmAlert(false);
    }
  };

  return (
    <>
      <AlertModal
        isOpen={showConfirmAlert}
        onDidDismiss={() => setShowConfirmAlert(false)}
        component={
          <div className='ion-padding'>
            <SelectForm
              label='Severity'
              name='severity'
              options={riskSeverityList}
              value={valueRisk}
              onChange={(key: string, value: any) => {
                setValueRisk(value);
              }}
              clearValue={() => {
                setValueRisk('');
              }}
            />
          </div>
        }
        buttons={[
          {
            text: 'Cancel',
            handler: () => setShowConfirmAlert(false)
          },
          {
            text: 'Save',
            handler: () => handlerUpdateSeverity(valueRisk)
          }
        ]}
      />
      <IonRow className='mb-16' key={index}>
        <IonCol className='background-row-color'>
          <IonRow className='ion-justify-content-between ion-text-left'>
            <IonCol size='10'>
              <IonLabel className='ml-1 ion-float-left'>
                {getRecommendationRiskData(data)}
              </IonLabel>
            </IonCol>
            <IonCol>
              <div className='flex ion-justify-content-end ion-align-items-center'>
                <IonIcon
                  icon={pencilOutline}
                  className={`font-24px cursor-pointer ${
                    isReadOnlyMode ? 'read-only' : ''
                  }`}
                  onClick={() => {
                    openRiskSeverityModal();
                  }}
                />
                {data.risk && data.risk.severity && (
                  <IonBadge
                    className={`cursor-default font-bold font-size12px ml-05 py-03 text-uppercase rounded-27 w-60 text-9 text-white py-05 px-18 mr-1  md hydrated ${getSeverityColor(
                      data.risk && data.risk.severity ? data.risk.severity : ''
                    )}`}
                  >
                    {getSeverityAbbreviation(
                      data && data.risk.severity ? data.risk.severity : ''
                    )}
                  </IonBadge>
                )}
                <IonIcon
                  icon={unlinkOutline}
                  mode='md'
                  className={`font-24px cursor-pointer ${
                    data.risk && !data.risk.severity ? 'ml-05' : ''
                  } ${isReadOnlyMode ? 'read-only' : ''}`}
                  onClick={() => {
                    dispatch({
                      type: acceptDeleteRiskUpdated.type,
                      payload: false
                    });
                    presentAlert({
                      cssClass: 'my-css',
                      message:
                        'Are you sure that you want to unlink this Risk?',
                      inputs: [
                        {
                          type: 'checkbox',
                          label: 'Delete Risk?',
                          handler: (item: any) => {
                            handleSetAcceptDeleteRisk(item.checked);
                          },
                          checked: false
                        }
                      ],
                      buttons: [
                        'Cancel',
                        {
                          text: 'Ok',
                          handler: () => removeRisk(data.id, data.idRisk)
                        }
                      ]
                    });
                  }}
                ></IonIcon>
              </div>
            </IonCol>
          </IonRow>
        </IonCol>
      </IonRow>
    </>
  );
};

export default Risk;
